/**
 * Deterministic Tailwind class lookups for application state UI.
 * Use full literal strings so Tailwind's content scanner includes only these utilities.
 * Do not build class names with string concatenation or template literals.
 */

export type StateButtonColor = 'purple' | 'green' | 'red' | 'emerald' | 'blue';

/** Button background/border classes for application state (save/state button). */
export const STATE_BUTTON_COLOR_CLASSES: Record<StateButtonColor | 'default', string> = {
  purple: 'bg-purple-50 dark:bg-purple-900/30 border-purple-200 dark:border-purple-700',
  green: 'bg-green-50 dark:bg-green-900/30 border-green-200 dark:border-green-700',
  red: 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-700',
  emerald: 'bg-emerald-50 dark:bg-emerald-900/30 border-emerald-200 dark:border-emerald-700',
  blue: 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700',
  default: 'bg-white/60 dark:bg-gray-800/60 border-gray-200 dark:border-gray-700',
};

/** Icon text color classes for application state. */
export const STATE_ICON_COLOR_CLASSES: Record<StateButtonColor | 'default', string> = {
  purple: 'text-purple-700 dark:text-purple-300',
  green: 'text-green-700 dark:text-green-300',
  red: 'text-red-700 dark:text-red-300',
  emerald: 'text-emerald-700 dark:text-emerald-300',
  blue: 'text-blue-700 dark:text-blue-300',
  default: 'text-gray-400 dark:text-gray-500',
};

export type ApplicationStateLabelValue = 'interviewing' | 'offer' | 'rejected' | 'hired' | 'applied' | '';

/** Select/label border and text color per application state. */
export const STATE_LABEL_CLASSES: Record<ApplicationStateLabelValue, string> = {
  interviewing: 'text-purple-700 dark:text-purple-300 border-purple-300 dark:border-purple-600',
  offer: 'text-green-700 dark:text-green-300 border-green-300 dark:border-green-600',
  rejected: 'text-red-700 dark:text-red-300 border-red-300 dark:border-red-600',
  hired: 'text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-600',
  applied: 'text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-600',
  '': 'text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600',
};

export function getStateLabelClass(
  stateVal: string | null | undefined,
  isApplied: boolean
): string {
  if (stateVal === 'interviewing' || stateVal === 'offer' || stateVal === 'rejected' || stateVal === 'hired') {
    return STATE_LABEL_CLASSES[stateVal as keyof typeof STATE_LABEL_CLASSES];
  }
  if (isApplied) return STATE_LABEL_CLASSES.applied;
  return STATE_LABEL_CLASSES[''];
}
